import {
    AppointmentPhysicalStoreInformations,
    Appointments,
    UserEyeExam,
} from '@interfaces/myAppointmentInterfaces';
import { getLabelFallback } from '@utils/utils';

export const EYE_EXAMS_CATEGORIES = ['upcoming', 'past'] as const;

export type EyeExamsCategories = typeof EYE_EXAMS_CATEGORIES[number];

export const EyeExamsConfig: {
    [key in EyeExamsCategories]: {
        labelKey?: string;
        eyeExams: UserEyeExam[];
    };
} = {
    upcoming: {
        labelKey: 'DASHBOARD_MANAGE_EYE_EXAMS_CARD_TITLE',
        eyeExams: [],
    },
    past: {
        labelKey: 'MYAPPOINTMENT_EYE_EXAMS_PAST_LABEL',
        eyeExams: [],
    },
};

export const replaceLabelPlaceholder = (
    label: string,
    substring: string,
    newSubString: string
): string => getLabelFallback(label).replace(substring, newSubString);

/** The function below returns the in-store services appointments lists */

export const mapInStoreServicesAppointments = (data: any): Appointments[] => {
    return data?.map((appointment: any) => mapInStoreServicesAppointment(appointment)) ?? [];
};

/** The function below returns the single mapped in-store services appointment */

export const mapInStoreServicesAppointment = (appointment: any): Appointments => {
    return {
        visitPurpose: appointment?.appType && mapVisitPurposeDescription(appointment.appType),
        changeAllowed: appointment?.changeAllowed,
        date: appointment?.date,
        appointmentId: appointment?.id,
        storeNumber: appointment?.office?.storeNumber,
    };
};

/** The function below returns the visit purpose description */

export const mapVisitPurposeDescription = (visitPurpose: string): string => {
    switch (visitPurpose) {
        case 'PDISP':
            return 'Pair Dispense';
        case 'SHOP':
            return 'Shop for Eyewear';
        case 'STLC':
            return 'Ray Ban Stories';
        case 'TUNEUP':
            return 'Tune Up';
        default:
            return visitPurpose;
    }
};

/** The function below returns the physical store mapped informations */
export const mapPhysicalStoreInformations = (
    physicalStore: any
): AppointmentPhysicalStoreInformations => {
    return {
        phoneNumber: physicalStore?.telephone1?.trim(),
        location: {
            officeAddress: physicalStore?.addressLine?.[0],
            city: physicalStore?.city?.trim(),
            province: physicalStore?.stateOrProvinceName?.trim(),
            postalCode: physicalStore?.postalCode?.trim(),
        },
    };
};
